export class ProModel {
    PRODUCT_CODE: string;
    PRODUCT_TYPE: string;
    PRODUCT_DESC: string;
    COST: number;
    NOTE: string;
}